import { render } from "./SinglePage.vue?vue&type=template&id=da1728ca&scoped=true"
import script from "./SinglePage.vue?vue&type=script&lang=js"
export * from "./SinglePage.vue?vue&type=script&lang=js"

import "./SinglePage.vue?vue&type=style&index=0&id=da1728ca&scoped=true&lang=css"

import exportComponent from "D:\\a\\utslappstoppen\\utslappstoppen\\utslappstoppen.app\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-da1728ca"]])

export default __exports__